// @flow
import * as _ from 'lodash';

import { getActiveEmergenciesForLineup } from './getActiveEmergenciesForLineup';
import { playersMatchIsScheduled } from './index';

type TLineup = {
	"1": [number],
	"2": [number],
	"3": [number],
	"4": [number],
	"5": [number],
	"6": [number],
	bench: [number],
	captain: number,
	vice_captain: number,
	emergency: {
		"1": number,
		"2": number,
		"3": number,
		"4": number,
		"5": number,
		"6": number
	}
}

export const getActivePlayerIdsForRound =
	(lineup: TLineup, players_by_id: Object, round: Object) => {

		if(_.isEmpty(players_by_id) || _.isEmpty(round) || _.isEmpty(lineup)) {
			return [];
		}

		const starting_player_ids = _.chain(lineup)
			.omit(['emergency', 'captain', 'vice_captain', 'bench'])
			.map(row => row)
			.reduce((row, all) => [...row, ...all], [])
			.value();

		const active_starting_player_ids = starting_player_ids.filter(player_id =>
			_.get(players_by_id, `${player_id}.stats.scores.${round.id.toString()}`));

		const active_emergency_player_ids =
			getActiveEmergenciesForLineup(lineup, players_by_id, round);

		const players_yet_to_play = starting_player_ids.filter(player_id =>
			playersMatchIsScheduled(player_id, players_by_id, round));

		return [
			...active_starting_player_ids,
			...players_yet_to_play,
			...active_emergency_player_ids
		];
		// return [];
	};

export default getActivePlayerIdsForRound;


// WEBPACK FOOTER //
// ./src/helpers/team/getActivePlayerIdsForRound.js